import * as React from "react";
import {DataGrid, gridClasses} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import {LOGIN_ROUTE, REPORT_ROUTE, REPORTS_ROUTE, TRACKS_ROUTE} from "../utils/constants";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import {getContracts, createContract, updateContract, deleteContract} from "../http/contractApi";
import {deleteUser, getAll} from "../http/userApi";
import {getTracks as getTrackList} from "../http/trackApi";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {Grid, Radio, RadioGroup, SvgIcon} from "@mui/material";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import {useEffect} from "react";
import Divider from '@mui/material/Divider';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SingerFields from "../components/contract/SingerFields";
import TrackFields from "../components/contract/TrackFields";
import {jwtDecode} from "jwt-decode";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import RefreshIcon from '@mui/icons-material/Refresh';
import Link from '@mui/icons-material/Link';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const getTrackInfo = (params) => {
    let result = [];

    let list = params.row.track;
    let trackList = params.row.trackList;
    // console.log(params);
    for (const listKey in list) {
        const info = trackList.find(item=>item.id === list[listKey]);
        // console.log(info);
        if(info){
            result.push(<div style={{whiteSpace: "nowrap"}}>
                <>{result.length ? <><br/></> : null}</>
                <>{params.field === 'artist' ? info.title : info.track}</>
            </div>);
        }
    }

    return result;
}

const getLicensiar = (params) => {
    // console.log(params);
    // list, type='artist'
    let result = [];

    let list = params.row.licensiar;

    for (const listKey in list) {
        // console.log(list[listKey]);
        let user = params.row.users.find(item => item.id === list[listKey].singersId);
        if (user) {
            result.push(<div style={{whiteSpace: "nowrap"}}>
                <>{result.length ? <><br/></> : null}</>
                <>{user.name}</>
            </div>);
        }
    }

    return result;
}

const renderReportAction = (params)=>{
    return <><Button
        key={"action1"+ params.id}
        // component="button"
        variant={"outlined"}
        color={"secondary"}
        // color="info"
        // onClick={(e)=>{e.preventDefault();}}
        // href={REPORT_ROUTE + "/" + params.id}
        >
        Отчеты
    </Button></>
}
const renderEditAction = (params)=>{
    return <><Button
        key={"action1"+ params.id}
        // component="button"
        // variant="contained"
        variant={"outlined"}
        color="info"
        // color="info"
        // onClick={(e)=>{e.preventDefault();}}
        // href={REPORT_ROUTE + "/" + params.id}
        >
        Редактировать
    </Button></>
}

const renderDate = (val) => {
    let result = val;
    let date = new Date(val);

    result = `${date.getFullYear()}-${date.getMonth() > 8 ? date.getMonth() + 1 : "0" + parseInt(date.getMonth() + 1)}-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`

    // console.log(result);

    return result;
}


const Singers = observer(({singersList, userList, singerChange, deleteSinger}) => {
    let result = [

    ];

    const renderItem = (singer, index) => {
        for (const userListKey in userList) {
            if (userList[userListKey].id === singer.singersId) {
                singer['singersId'] = parseInt(userListKey);
            }
        }
        return <SingerFields
            // key={"singer" + index}
            {...singer}
            userList={userList}
            onChange={(e, id) => {
                singerChange(e, index)
            }}
            onDelete={() => {
                deleteSinger(index)
            }}
        />
    }

    for (const singersListKey in singersList) {
        result.push(renderItem({
            ...singersList[singersListKey],
        }, singersListKey));
    }

    return <>{result}</>;
});


const Tracks = ({value, onChange, list}) => {
    console.log(value);

    const onChangeVal = (event) => {
        const info = {
            target: {
                value: event.target.value,
                name: "tracks"
            },
        };
        onChange(info);
    }

    return <Box
        width={"100%"}
        display="flex"
        flexDirection="column"
        justifyContent="stretch"
    >
        <FormControl>
            <Select
                multiple
                displayEmpty
                onChange={onChangeVal}
                value={value}
            >
                <MenuItem disabled value="">
                    <em>Placeholder</em>
                </MenuItem>
                {list && list.length ? list.map(({title, track, id}) => (
                    <MenuItem
                        key={id}
                        value={id}
                        style={{}}
                    >
                        {`${title} - ${track}`}
                    </MenuItem>
                )) : null}
            </Select>
        </FormControl>
    </Box>;
};

const Contracts = observer(() => {
    const [parse, setParse] = React.useState([]);
    const [dataToRender, setDataToRender] = React.useState([]);
    const [users, setUsers] = React.useState([]);
    const navigate = useNavigate();
    // const [columns, setColumns] = React.useState(null);
    const [editId, setEditId] = React.useState(0);
    const [trackList, setTrackList] = React.useState([]);
    const [columns, setColumns] = React.useState([]);
    const {user} = React.useContext(Context);
    const [token, setToken] = React.useState(localStorage.getItem("token") || "");
    const tkn = jwtDecode(token);
    const initialForm = {
        name: '',
        vatType: "disabled",
        profitPercent: 100,
        dateExpire: new Date(),
        tracks: [],
        singers: [],
        // licensiat: "АО \"Студия Андрея Резникова\"",
        licensiat: "Лицензиат",
        description: "",
        userId: tkn.id,
        responsible: "",
        role: "",
        opf: "fiz",
        appeal: "",
        vatNum: 7,
    };
    const [form, setForm] = React.useState(initialForm);
    const [showForm, setShowForm] = React.useState(false);

    const stringifyData = async (data, fields, cb, optionInfo) => {
        let result = "";
        let count = 0;

        for (const dataKey in data) {
            const item = data[dataKey];
            // console.log(item);
            // result += item[]
            if (count) {
                result += "<br />";
            }
            for (const fieldsKey in fields) {
                result += ` ${cb ? await cb(fields[fieldsKey], item[fields[fieldsKey]], optionInfo) : item[fields[fieldsKey]]}`;
            }
            count++;
        }

        return result;
    }

    const singersColRender = async (field, val, users) => {
        let result = val;

        if (field === "singersId") {
            let user = users.filter(user => user.id === val);
            console.log(user);
            user = user.length ? user[0] : 0;
            if (user) {
                result = user.name;
            }
        }

        return result;
    }

    const trackColRender = async (field, val) => {
        let result = val;

        if (field === 'title') {
            result = " - " + val;
        }

        return result;
    }

    const getData = async () => {
        try {
            const parsed = await getContracts();
            const users = await getUsers();
            const tracks = await getTracks();

            let info = [];
            let infoSaved = [];
            for (const parsedKey in parsed) {
                let row = parsed[parsedKey];
                let date = new Date(row.dateExpire);
                // console.log(date.toLocaleDateString("en-US"));
                // console.log(row);

                info.push({
                    id: row['id'],
                    name: row['name'],
                    singer: row['tracks'],
                    track: row['tracks'],
                    licensiar: row['singers'],
                    licensiat: row['licensiat'],
                    dateExpire: row['dateExpire'],
                    createdAt: row['createdAt'],
                    responsible: row['responsible'],
                    role: row['role'],
                    opf: row['opf'],
                    appeal: row['appeal'],
                    users,
                    trackList: tracks
                    // ...parsed[parsedKey],
                    // dateExpire: `${date.getFullYear()}-${date.getMonth() > 8 ? date.getMonth() + 1 : "0" + parseInt(date.getMonth() + 1)}-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`,
                    // singers: await stringifyData(parsed[parsedKey].singers, ['singersId'], singersColRender, users),
                    // tracks: await stringifyData(parsed[parsedKey].tracks, ['artist', 'title'], trackColRender),
                });
                infoSaved.push({
                    ...parsed[parsedKey],
                    dateExpire: `${date.getFullYear()}-${date.getMonth() > 8 ? date.getMonth() + 1 : "0" + parseInt(date.getMonth() + 1)}-${date.getDate()}`,
                    singers: parsed[parsedKey].singers,
                    tracks: parsed[parsedKey].tracks,
                });
            }
            setDataToRender([...info]);
            setParse([...infoSaved]);

            createColumns();

        } catch (error) {
            console.log(error);
            if (error?.response?.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    };

    const getUsers = async () => {
        try {
            const parsed = await getAll();
            setUsers([...parsed.filter(item => (item.role === "ARTIST"))]);
            return [...parsed.filter(item => (item.role === "ARTIST"))];
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    };

    const getTracks = async () => {
        try {
            const tracks = await getTrackList();
            setTrackList(tracks);
            return tracks;
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }

    };

    const refreshTracks = async (e)=>{
        e.preventDefault();
        await getTracks();
    }

    // useEffect(() => {
    //     (async () => {
    //         await getUsers();
    //     })();
    // }, []);

    useEffect(() => {
        (async () => {
            await getData();
        })();
    }, []);

    const createColumns = ()=>{
        setColumns([
            // {
            //   field: "id",
            //   headerName: "ID",
            //   width: 90,
            //   editable: false,
            //   sortable: true,
            // },
            {
                field: "name",
                headerName: "Номер договора",
                width: 150,
                editable: false,
                sortable: true,
                flex: 1,
                minWidth: 150,
            },
            {
                field: "artist",
                headerName: "Исполнитель",
                width: 150,
                flex: 1,
                minWidth: 150,
                editable: false,
                sortable: true,
                renderCell: getTrackInfo
            },
            {
                field: "title",
                headerName: "Трек",
                width: 150,
                flex: 1,
                minWidth: 150,
                editable: false,
                sortable: true,
                renderCell: getTrackInfo
            },
            {
                field: "licensiar",
                headerName: "Лицензиар",
                width: 150,
                flex: 1,
                minWidth: 150,
                editable: false,
                sortable: true,
                renderCell: getLicensiar
            },
            {
                field: "link",
                headerName: "Отчеты",
                flex: 0,
                editable: false,
                sortable: false,
                renderCell: renderReportAction
            },
            // {
            //     field: "edit",
            //     headerName: "Редактировать",
            //     flex: 0,
            //     minWidth: 180,
            //     editable: false,
            //     sortable: false,
            //     renderCell: renderEditAction
            // },
            {
                field: "dateExpire",
                headerName: "Дата Окончания",
                width: 150,
                editable: false,
                sortable: true,
                valueGetter: renderDate
            },
            {
                field: "createdAt",
                headerName: "Дата Добавления",
                width: 150,
                editable: false,
                sortable: true,
                valueGetter: renderDate
            },
        ]);
    }


    const onAddContract = async () => {
        try {
            console.log(user.getId());
            const response = await createContract({...form, userId: user.getId()});
            await getData();
            setForm(initialForm)
            setEditId(0);
        } catch (error) {
            console.log(error);
        }
    }
    const onEditContract = async () => {
        try {
            const response = await updateContract(editId, {...form, userId: user.getId()});
            console.log(form);
            await getData();
            setForm(initialForm)
            setEditId(0);
        } catch (error) {
            console.log(error);
        }
    }

    const onDelete = async () => {
        console.log(editId);
        if (window.confirm("Точно удалить договор?")) {
            await deleteContract(editId);
            await getData();
            setForm(initialForm)
            setShowForm(false);
            setEditId(0);
        }
    }

    const handleCellClick = (props)=>{
        if(props.field === 'link'){
            navigate(REPORTS_ROUTE + "/" + props.id);
        } else {
            rowClick({row: props.row});
        }
    }

    const onSubmit = async () => {
        console.log(form);
        if (editId) {
            await onEditContract();
            setShowForm(false);
        } else {
            await onAddContract();
            setShowForm(false);
        }
    }

    const formChange = (e, newVal, test) => {
        if (e.target.type === "checkbox") {
            setForm(prevState => ({...prevState, [e.target.name]: e.target.checked}));
        } else if (newVal && e.target.type === "button") {
            let name = e.target.parentNode.getAttribute("name");
            console.log(name);
            setForm(prevState => ({...prevState, [name]: newVal + ""}));
        } else {
            setForm(prevState => ({...prevState, [e.target.name]: e.target.value}));
        }
    }

    const singerChange = (e, id) => {
        setForm(prevState => {
            let result = {...prevState};

            console.log(result["singers"]);
            result["singers"][id] = {...result["singers"][id], [e.target.name]: e.target.value}
            console.log(id, e.target.name, e.target.value);
            return result
        });
        // ({ ..., ["track"]: e.target.value }));
    }

    const handleTrackChange = (event, newValue)=>{
        let tracks = [];
        for (const item of newValue) {
            if(item && item.id && item.title){
                tracks.push(item.id);
            } else {
                tracks.push(item);
            }
        }

        console.log(tracks);

        setForm(prevState => ({
            ...prevState,
            tracks: tracks
        }));
    }

    const addBeneficiary = (e) => {
        e.preventDefault();

        setForm(prevState => ({
            ...prevState,
            ['singers']: prevState.singers ? [...prevState.singers, {
                singersId: null,
                percent: 0,
                vat: 0,
                type: 0
            }] : [{singersId: null, percent: 0, vat: 0, type: 0}]
        }));
    }

    const deleteTrack = (id) => {
        console.log(id);
        let result = [];
        for (const tracksKey in form.tracks) {
            let item = form.tracks[tracksKey];
            console.log(tracksKey, id);
            if (parseInt(tracksKey) !== parseInt(id)) {
                result.push(item);
            }
        }
        setForm({
            ...form,
            tracks: result,
        });
    }

    const deleteSinger = (id) => {
        console.log(id);
        let result = [];
        for (const singersKey in form.singers) {
            let item = form.singers[singersKey];
            if (parseInt(singersKey) !== parseInt(id)) {
                result.push(item);
            }
        }
        setForm({
            ...form,
            singers: result,
        });
    }

    const rowClick = ({row}) => {
        if (row?.id) {
            let {userId, createdAt, updatedAt, ...info} = row;
            setEditId(info.id);
            // console.log(info);
            // console.log(parse);
            let contract = parse.find(item => item.id === info.id);
            if (contract) {
                setForm({
                    ...info,
                    dateExpire: info.dateExpire.toString().split('T')[0],
                    tracks: contract.tracks,
                    singers: contract.singers,
                    profitPercent: contract.profitPercent,
                    vatType: contract.vatType,
                    vatNum: contract.vatNum,
                    description: contract.description,
                    userId
                });
                setShowForm(true);
            }
        }
    };

    const Yurlico = ()=>{
        if(form.opf === 'fiz'){
            return null;
        }
        return (
            <Box
                sx={{
                    marginTop: 1,
                    marginBottom: 1
                }}
            >
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Divider
                    />
                    <Grid
                        container
                        // display={'flex'}
                        justifyContent={'space-between'}
                        sx={{
                            marginTop: 1,
                            marginBottom: 1
                        }}
                        spacing={2}
                    >
                        <Grid item>
                            <Typography variant="h5" gutterBottom>Настройки Юр лица</Typography>
                        </Grid>
                    </Grid>
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        justifyContent={'stretch'}
                        gap={2}
                    >
                        <ToggleButtonGroup
                            value={form['vatType']}
                            name={'vatType'}
                            exclusive
                            onChange={formChange}
                        >
                            <ToggleButton value="disabled">Отсутствует</ToggleButton>
                            <ToggleButton value="pre">С дохода САР</ToggleButton>
                            <ToggleButton value="post">С дохода исполнителя</ToggleButton>
                        </ToggleButtonGroup>
                        {form.vatType !== 'disabled' ? <TextField
                            className="login__page__item"
                            label="Налог на оборот (%)"
                            variant="outlined"
                            color="secondary"
                            name={'vatNum'}
                            type='number'
                            value={form['vatNum']}
                            onChange={formChange}
                        /> : null}
                    </Box>
                </Box>
            </Box>
        )
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="flex-end"
                width={'100%'}
                p={2}
            >
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => {
                        setEditId(0);
                        setShowForm(true);
                    }}
                >Создать договор</Button>
            </Box>
            <Dialog
                open={showForm}
                onClose={() => {
                    setShowForm(false);
                    setEditId(0);
                }}
                my={4}
                gap={4}
                p={2}
                sx={{border: "2px solid grey"}}
            >
                <Box
                    p={2}
                    width={"100%"}
                >
                    <Typography variant="h4" gutterBottom>
                        {editId ? "Редактирование договора" : "Создание договора"}
                    </Typography>
                </Box>
                <Box
                    width={"100%"}
                    p={2}
                    rowGap={2}
                    display="flex"
                    flexDirection="column"
                >
                    <TextField
                        className="login__page__item"
                        label="Номер договора"
                        variant="outlined"
                        color="secondary"
                        name={'name'}
                        value={form['name']}
                        onChange={formChange}
                    />
                    <ToggleButtonGroup
                        value={form['opf']}
                        name={'opf'}
                        exclusive
                        onChange={formChange}
                    >
                        <ToggleButton value="fiz">Физлицо</ToggleButton>
                        <ToggleButton value="yur">Юрлицо</ToggleButton>
                    </ToggleButtonGroup>
                    <TextField
                        className="login__page__item"
                        label="ФИО подписанта"
                        variant="outlined"
                        color="secondary"
                        name={'responsible'}
                        value={form['responsible']}
                        onChange={formChange}
                    />
                    <TextField
                        className="login__page__item"
                        label="Должность"
                        variant="outlined"
                        color="secondary"
                        name={'role'}
                        value={form['role']}
                        onChange={formChange}
                    />
                    <TextField
                        className="login__page__item"
                        label="Наименование лицензиата в договоре"
                        variant="outlined"
                        color="secondary"
                        name={'licensiat'}
                        value={form['licensiat']}
                        onChange={formChange}
                    />
                    <TextField
                        className="login__page__item"
                        label="Наименование стороны контрагента в договоре"
                        variant="outlined"
                        color="secondary"
                        name={'appeal'}
                        value={form['appeal']}
                        onChange={formChange}
                    />
                    <TextField
                        className="login__page__item"
                        label="Дата окончания договора"
                        variant="outlined"
                        color="secondary"
                        name={'dateExpire'}
                        type={'date'}
                        value={form['dateExpire']}
                        onChange={formChange}
                    />
                    {/*<TextField*/}
                    {/*    className="login__page__item"*/}
                    {/*    label="Процент вознаграждения САР (%)"*/}
                    {/*    variant="outlined"*/}
                    {/*    type='number'*/}
                    {/*    color="secondary"*/}
                    {/*    name={'profitPercent'}*/}
                    {/*    value={form['profitPercent']}*/}
                    {/*    onChange={formChange}*/}
                    {/*/>*/}

                    <Yurlico />

                    <Box
                        sx={{
                            marginTop: 1,
                            marginBottom: 1
                        }}
                    >
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                        >
                            <Divider
                            />
                            <Grid
                                container
                                // display={'flex'}
                                justifyContent={'space-between'}
                                sx={{
                                    marginTop: 1,
                                    marginBottom: 1
                                }}
                                spacing={2}
                            >
                                <Grid item>
                                    <Typography variant="h5" gutterBottom>Треки</Typography>
                                </Grid>
                                <Grid item flexGrow={1}>
                                    {/*<Typography gutterBottom>Обновить</Typography>*/}
                                    <SvgIcon
                                        color="secondary"
                                        onClick={refreshTracks}
                                    >
                                        <RefreshIcon />
                                        {/*<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1"*/}
                                        {/*     viewBox="0 0 118.04 122.88">*/}
                                        {/*    <path*/}
                                        {/*        d="M16.08,59.26A8,8,0,0,1,0,59.26a59,59,0,0,1,97.13-45V8a8,8,0,1,1,16.08,0V33.35a8,8,0,0,1-8,8L80.82,43.62a8,8,0,1,1-1.44-15.95l8-.73A43,43,0,0,0,16.08,59.26Zm22.77,19.6a8,8,0,0,1,1.44,16l-10.08.91A42.95,42.95,0,0,0,102,63.86a8,8,0,0,1,16.08,0A59,59,0,0,1,22.3,110v4.18a8,8,0,0,1-16.08,0V89.14h0a8,8,0,0,1,7.29-8l25.31-2.3Z"/>*/}
                                        {/*</svg>*/}
                                    </SvgIcon>
                                </Grid>
                                <Grid item>
                                    <a href={TRACKS_ROUTE} target={"_blank"}>
                                        <SvgIcon
                                            color="secondary"
                                            // onClick={addTrack}

                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ff6000">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <path
                                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                                            </svg>
                                        </SvgIcon>
                                    </a>
                                </Grid>
                            </Grid>
                            <Box>
                                {/*<Tracks*/}
                                {/*  value={form.tracks}*/}
                                {/*  onChange={formChange}*/}
                                {/*  list={trackList}*/}
                                {/*/>*/}
                                <Autocomplete
                                    multiple
                                    options={trackList}
                                    value={form.tracks}
                                    getOptionLabel={(option) => {
                                        // console.log(option, trackList);
                                        const info = trackList.find(item=>item.id === option);
                                        if(info){
                                            return `${info.title} - ${info.track}`
                                        }
                                        return ``
                                    }}
                                    filterSelectedOptions
                                    onChange={handleTrackChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Артист - трек"
                                            // placeholder="Артист - трек"
                                        />
                                    )}
                                    disableCloseOnSelect
                                    renderOption={(props, option, { selected }) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                            <li key={key} {...optionProps}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {`${option.title} - ${option.track}`}
                                            </li>
                                        );
                                    }}
                                    // renderTags={(value, getTagProps) => {
                                    //
                                    //     return value.map((option, index) => {
                                    //         const {key, ...itemProps} = getTagProps({index});
                                    //         let info = trackList.find(track => track.id === option);
                                    //         console.log(info, trackList);
                                    //
                                    //         return (
                                    //             <Chip variant="outlined" label={`${info.title} - ${info.track}`} key={key} {...itemProps} />
                                    //             // <div>123</div>
                                    //         );
                                    //     })
                                    // }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.id === value
                                    }}
                                />
                            </Box>

                        </Box>
                    </Box>
                    <Box
                    >
                        <Divider
                        />
                        <Box
                            display={'flex'}
                            justifyContent={'space-between'}
                            sx={{
                                marginTop: 1,
                                marginBottom: 1
                            }}
                        >
                            <Typography variant="h5" gutterBottom>Лицензиары</Typography>
                            <SvgIcon
                                color="secondary"
                                onClick={addBeneficiary}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                     fill="#ff6000">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                                </svg>
                            </SvgIcon>
                        </Box>
                        <Box>
                            <Singers
                                singerChange={singerChange}
                                deleteSinger={deleteSinger}
                                userList={users}
                                singersList={form.singers}
                            />
                            {/*{form.singers && form.singers.length > 0 ? form.singers.map((singer, index) => <SingerFields key={"singer" + index} {...userList.filter(user => user.id === )} userList={users} onChange={(e)=>{singerChange(e,index)}} onDelete={()=>{deleteSinger(index)}}/>) : ''}*/}
                        </Box>
                    </Box>
                    <TextField
                        className="login__page__item"
                        label="Примечание"
                        variant="outlined"
                        color="secondary"
                        name={'description'}
                        value={form['description'] || ""}
                        onChange={formChange}
                        multiline
                        rows={4}
                    />
                </Box>
                <Box
                    p={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={4}
                >
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => {
                            setForm(initialForm);
                            setEditId(0);
                            setShowForm(false);
                        }}
                    >
                        Отмена
                    </Button>
                    {editId ? <Button
                        variant="contained"
                        color="info"
                        onClick={() => {
                            navigate(REPORTS_ROUTE + '/' + editId,)
                        }}
                    >
                        Отчеты
                    </Button> : ""}
                    {editId ?
                        <Button
                            variant="contained"
                            color="error"
                            onClick={onDelete}
                        >
                            Удалить
                        </Button> : null
                    }
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onSubmit}
                    >
                        {editId ? "Обновить договор" : "Добавить договор"}

                    </Button>
                </Box>
            </Dialog>

            {parse && trackList && trackList.length > 0 && (
                <Box sx={{height: "100%", width: "100%"}}>
                    <DataGrid
                        rows={dataToRender}
                        columns={columns}
                        sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 1,
                            },
                        }}
                        getRowHeight={() => 'auto'}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        disableRowSelectionOnClick
                        onCellClick={handleCellClick}
                        // onRowClick={rowClick}
                    />
                </Box>
            )}
        </div>
    );
});

export default Contracts;
